// Публичный конфиг виджета Jivo (Tech-Story-jivo-admin-settings, R-FE-1):
// standalone axios-клиент БЕЗ interceptors — на /api/public никогда не уходит
// Authorization и не триггерится 401-refresh (api/client.ts:58-77 вешает Bearer
// на общий инстанс при наличии токена в localStorage).

import axios from 'axios';

/** Публичный конфиг виджета (wire PublicJivoConfigDto): только enabled + widgetId. */
export interface PublicJivoConfig {
  enabled: boolean;
  widgetId: string | null;
}

// baseURL — конвенция VITE_API_BASE_URL (канон api/client.ts:15,53): при раздельных
// origin FE/API в проде запрос уходит на API-origin, а не на FE-origin.
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? '';

/** Отдельный axios-инстанс без interceptors (анонимный — без Bearer). */
const publicClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10_000,
});

/** GET /api/public/jivo-config — конфиг рендера виджета на лендинге (анонимно). */
export async function fetchPublicJivoConfig(): Promise<PublicJivoConfig> {
  const { data } = await publicClient.get<PublicJivoConfig>('/api/public/jivo-config');
  return data;
}
